var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EspSolutionTypeMedia',{attrs:{"spot":_vm.spot,"eventId":_vm.eventId,"userId":_vm.userId,"teamId":_vm.teamId,"maxSize":51200,"allowedMimeType":"video.*"},on:{"input":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }